import React from "react";
import PropTypes from "prop-types";

import "./liveMarker.scss";

export const LiveMarker = ({
  callback,
  handleMouseLeave,
  status,
  score,
  homeTeam,
  awayTeam,
  showStadiumName,
  venue,
  matchTime,
}) => (
  <div
    className="live-marker"
    onClick={callback}
    onMouseLeave={() => handleMouseLeave()}
  >
    <svg
      className="liveIcon"
      width={136.441}
      height={128.406}
      viewBox="0 0 136.441 128.406"
    >
      <g data-name="Group 1997">
        <g data-name="Group 1996">
          <g data-name="020---Stadium">
            <path
              d="M44.657 122.349c0 2.506-9.826 5.3-21.952 5.3s-21.948-2.795-21.948-5.3c0-1.045 1.7-2.011 4.557-2.771v.008a.294.294 0 00-.015.114c0 1.408 4.368 3.043 10.6 3.77.969.121 1.976.212 3.028.273a55.84 55.84 0 003.785.121c1.575 0 3.1-.061 4.542-.174a50.619 50.619 0 003.028-.31c5.821-.772 9.841-2.324 9.841-3.679a.294.294 0 00-.015-.114v-.009c2.849.76 4.549 1.726 4.549 2.771z"
              fill="#2e2e2e"
            />
            <path
              data-name="Shape"
              d="M40.105 119.578v.008a.294.294 0 01.015.114.94.94 0 01-.216.553c1.578.627 2.487 1.34 2.487 2.1 0 2.427-9.218 5.123-20.817 5.291q.565.008 1.135.008c12.127 0 21.952-2.793 21.952-5.3.001-1.048-1.702-2.014-4.556-2.774z"
              fill="#2e2e2e"
            />
            <path
              data-name="Shape"
              d="M44.655 101.82l-.068.515c-.28.757-1.287 1.469-2.824 2.1a11.219 11.219 0 00-4.466-2.188 41.609 41.609 0 00-5.753-1.219 58.689 58.689 0 00-6.086-.575c-.908-.038-1.832-.061-2.748-.061s-1.839.023-2.748.061a58.689 58.689 0 00-6.086.575 41.608 41.608 0 00-5.753 1.219 11.119 11.119 0 00-4.468 2.192c-1.537-.636-2.543-1.347-2.824-2.1l-.068-.515c.222-2.888 11.192-5.212 21.947-5.212s21.725 2.324 21.945 5.208z"
              fill="#666bf1"
            />
            <path
              data-name="Shape"
              d="M.764 101.82l.068.515a1.166 1.166 0 01-.075-.424.369.369 0 01.007-.091z"
              fill="#0377bc"
            />
            <path
              data-name="Shape"
              d="M41.762 104.439a28.666 28.666 0 01-5.036 1.439 18.231 18.231 0 00-3.724-.939 58.369 58.369 0 00-3.944-.484c-1.363-.121-2.8-.2-4.269-.242-.689-.023-1.385-.03-2.082-.03s-1.393.008-2.082.03a62.5 62.5 0 00-8.213.726 18.365 18.365 0 00-3.724.939 28.666 28.666 0 01-5.032-1.439 11.119 11.119 0 014.47-2.187 41.609 41.609 0 015.753-1.219 58.688 58.688 0 016.086-.575c.908-.038 1.832-.061 2.748-.061s1.839.023 2.748.061a58.688 58.688 0 016.086.575 41.609 41.609 0 015.753 1.219 11.219 11.219 0 014.466 2.188z"
              fill="#7f8e94"
            />
            <path
              data-name="Shape"
              d="M36.728 105.881a71.47 71.47 0 01-14.018 1.328 71.47 71.47 0 01-14.02-1.328 18.365 18.365 0 013.724-.939 58.369 58.369 0 013.944-.484c1.363-.121 2.8-.2 4.269-.242.689-.027 1.383-.035 2.083-.035s1.393.008 2.082.03a62.5 62.5 0 018.213.726 18.231 18.231 0 013.724.939z"
              fill="#666bf1"
            />
            <path
              data-name="Shape"
              d="M44.662 101.911a1.166 1.166 0 01-.076.424l.068-.515a.368.368 0 01.008.091z"
              fill="#0377bc"
            />
            <path
              data-name="Shape"
              d="M44.586 102.334l-.008.061v.008l-4.473 17.171v.008a.294.294 0 01.015.114c0 1.355-4.02 2.907-9.841 3.679v-3.301a6.064 6.064 0 00-6.056-6.056h-2.27a6.064 6.064 0 00-6.056 6.056v3.391c-6.23-.727-10.6-2.362-10.6-3.77a.294.294 0 01.015-.114v-.007L.841 102.402v-.008l-.008-.06c.28.757 1.287 1.469 2.824 2.1a28.666 28.666 0 005.033 1.44 71.47 71.47 0 0014.019 1.332 71.47 71.47 0 0014.024-1.332 28.666 28.666 0 005.034-1.438c1.537-.636 2.543-1.347 2.824-2.1z"
              fill="#666bf1"
            />
            <path
              data-name="Shape"
              d="M41.779 104.431l-3.945 15.154a.3.3 0 01.015.114c0 1.17-3 2.486-7.57 3.321v.354c5.821-.772 9.841-2.324 9.841-3.679a.3.3 0 00-.015-.114v-.007l4.474-17.172v-.008l.008-.061c-.28.755-1.281 1.464-2.808 2.098z"
              fill="#0377bc"
            />
            <path
              data-name="Shape"
              d="M27.251 120.078v3.611a57.94 57.94 0 01-4.542.174c-1.3 0-2.566-.038-3.785-.121v-3.664a3.028 3.028 0 013.028-3.028h2.272a3.028 3.028 0 013.027 3.028z"
              fill="#37474f"
            />
            <path
              data-name="Shape"
              d="M30.28 120.078v3.3a49.02 49.02 0 01-3.028.31v-3.61a3.028 3.028 0 00-3.028-3.028h-2.271a3.028 3.028 0 00-3.028 3.028v3.664a45.17 45.17 0 01-3.028-.273v-3.391a6.064 6.064 0 016.056-6.056h2.271a6.064 6.064 0 016.056 6.056z"
              fill="#ffeb3a"
            />
            <g data-name="Group 869" fill="#ef314c">
              <path
                data-name="Shape"
                d="M14.383 89.042l5.3 2.271-5.3 2.271zM39.363 91.313l5.3 2.271-5.3 2.271zM6.056 91.313l5.3 2.271-5.3 2.271zM31.036 89.042l5.3 2.271-5.3 2.271zM22.71 88.285l5.3 2.271-5.3 2.271z"
              />
            </g>
            <path
              data-name="Shape"
              d="M8.327 119.322a.757.757 0 01-.734-.573l-2.271-9.084a.757.757 0 011.469-.368l2.271 9.084a.757.757 0 01-.551.918.733.733 0 01-.184.023z"
              fill="#2e2e2e"
            />
            <path
              data-name="Shape"
              d="M44.96 94.279a.757.757 0 000-1.391l-5.3-2.271a.757.757 0 00-1.055.7V97.6a55.04 55.04 0 00-6.813-1.2v-2.317l4.84-2.074a.757.757 0 000-1.391l-5.298-2.272a.757.757 0 00-1.055.7v7.187a81.275 81.275 0 00-6.813-.378v-2.527l4.84-2.074a.757.757 0 000-1.391l-5.298-2.274a.757.757 0 00-1.055.7v7.57c-2.139.024-4.48.151-6.813.378v-2.154l4.84-2.074a.757.757 0 000-1.391l-5.299-2.272a.757.757 0 00-1.055.7V96.4a55.041 55.041 0 00-6.813 1.2v-1.246l4.84-2.074a.757.757 0 000-1.391l-5.3-2.271a.757.757 0 00-1.055.7v6.7c-3.154.962-5.3 2.254-5.3 3.9a4.025 4.025 0 00.108.681l4.288 16.462C1.453 119.946 0 121.023 0 122.349c0 3.623 11.742 6.056 22.709 6.056s22.709-2.433 22.709-6.056c0-1.326-1.453-2.4-4.39-3.288l4.282-16.469a4.345 4.345 0 00.108-.681c0-1.642-2.145-2.934-5.3-3.9v-1.657zm-4.84-1.818l2.62 1.123-2.62 1.122zm-8.327-2.271l2.62 1.123-2.62 1.123zm-8.327-.757l2.62 1.123-2.62 1.123zm-8.327.757l2.62 1.123-2.619 1.122zm-8.326 2.271l2.62 1.123-2.62 1.122zm1.211 10.62l2.38 1.49a14.37 14.37 0 00-1.768.519 34.884 34.884 0 01-3.379-.886 14.919 14.919 0 012.767-1.123zm5.515-1.226l1.439 1.973c-.843.092-1.645.2-2.391.317l-2.574-1.612a44.04 44.04 0 013.524-.682zm21.877.681l-2.574 1.612a46.698 46.698 0 00-2.391-.317l1.438-1.977c1.247.2 2.437.423 3.523.683zm4.751 1.665a34.884 34.884 0 01-3.379.886 14.37 14.37 0 00-1.768-.519l2.375-1.488a14.919 14.919 0 012.769 1.123zm-17.457.737a64.888 64.888 0 0110.435.8 73.933 73.933 0 01-10.435.718 73.933 73.933 0 01-10.435-.718 64.889 64.889 0 0110.434-.8zm5.99-1.271a71.415 71.415 0 00-3.007-.181l.4-2.234c1.4.076 2.777.2 4.1.364zm-4.537-.227c-.481-.008-.965-.015-1.45-.015s-.968.007-1.45.016l-.4-2.254c.616-.02 1.233-.033 1.85-.033s1.234.013 1.85.033zm-4.825-2.188l.4 2.234a68.2 68.2 0 00-3.007.181l-1.489-2.051a59.22 59.22 0 014.092-.364zm3.375 6.714c6.913 0 16.324-1.1 20.526-3.412l-3.864 14.825a.762.762 0 00-.019.334c-.195.717-3.266 2.029-8.322 2.795v-2.43a6.82 6.82 0 00-6.813-6.813h-2.269a6.82 6.82 0 00-6.812 6.813v2.534c-5.509-.746-8.883-2.156-9.079-2.908a.757.757 0 00-.03-.37l-3.848-14.779c4.2 2.314 13.613 3.412 20.526 3.412zm3.785 15.019c-1.2.076-2.458.12-3.785.12-1.052 0-2.057-.031-3.028-.08v-2.947a2.271 2.271 0 012.271-2.271h2.271a2.271 2.271 0 012.271 2.271zm-2.271-6.692h-2.275a3.789 3.789 0 00-3.785 3.785v2.85q-.777-.059-1.514-.136v-2.714a5.3 5.3 0 015.3-5.3h2.271a5.3 5.3 0 015.3 5.3v2.635c-.489.058-.995.111-1.514.157v-2.792a3.789 3.789 0 00-3.787-3.785zm19.673 6.056c0 1.388-8.007 4.542-21.2 4.542s-21.2-3.154-21.2-4.542c0-.307.711-1.06 3.278-1.833 1.54 2.487 9.982 4.1 17.918 4.1s16.378-1.618 17.918-4.1c2.58.773 3.286 1.526 3.286 1.833zm-.022-20.528c.091.764-1.287 1.428-1.989 1.741-3.7-2.977-14.215-3.922-19.184-3.922-4.915 0-15.379.857-19.184 3.92a8.05 8.05 0 01-1.145-.606 2.078 2.078 0 01-.766-.724c-.4-.846.614-1.328 1.387-1.721 4.689-2.381 14.267-3.14 19.712-3.14 5.695 0 13.07.681 18.063 2.453a7.873 7.873 0 012.708 1.376 1.045 1.045 0 01.403.622z"
              fill="#2e2e2e"
            />
          </g>
          <path
            data-name="Path 1333"
            d="M24.006 24.999s12.571 7.349 33.184 4.037c19.544-3.129 37.765-6.683 68.378 1.285v47.176s-28.155-9.676-53.8-5.36-40.147 2.659-47.76-2.828"
            fill="#fff"
          />
          <path
            data-name="Rectangle 219"
            fill="#f03737"
            d="M21.115 24.734h3.51v82.69h-3.51z"
          />
        </g>
        <text
          data-name="2 : 0"
          transform="translate(60.441 57)"
          fill="#2e2e2e"
          fontSize={15}
          fontFamily="Poppins-SemiBold, Poppins"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {score}
          </tspan>
        </text>
        <g
          data-name="Ellipse 158"
          transform="translate(110.441 12)"
          fill="#ffda1a"
          stroke="#fcfcfc"
          strokeWidth={2}
        >
          <circle cx={13} cy={13} r={13} stroke="none" />
          <circle cx={13} cy={13} r={12} fill="none" />
        </g>
        <g
          data-name="Ellipse 159"
          transform="translate(9.441)"
          fill="#ffda1a"
          stroke="#fcfcfc"
          strokeWidth={2}
        >
          <circle cx={13} cy={13} r={13} stroke="none" />
          <circle cx={13} cy={13} r={12} fill="none" />
        </g>
        <text
          data-name="30'"
          transform="translate(116.441 29)"
          fill="#2e2e2e"
          fontSize={10}
          fontFamily="Poppins-SemiBold, Poppins"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {matchTime ? matchTime + "'" : "--"}
          </tspan>
        </text>
        <text
          transform="translate(17.441 17)"
          fill="#2e2e2e"
          fontSize={10}
          fontFamily="Poppins-SemiBold, Poppins"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {status}
          </tspan>
        </text>
      </g>
    </svg>
    <div className="live-flag-images-container">
      <img className="live-flag-img" src={homeTeam}  onError={(e) => e.target.src = homeTeam} alt="logo" />
      <img className="live-flag-img" src={awayTeam}  onError={(e) => e.target.src = awayTeam} alt="logo" />
    </div>
    {showStadiumName(venue)}
  </div>
);

LiveMarker.propTypes = {
  callback: PropTypes.func,
  handleMouseLeave: PropTypes.func,
  status: PropTypes.string,
  score: PropTypes.string,
  homeTeam: PropTypes.string,
  awayTeam: PropTypes.string,
  showStadiumName: PropTypes.func,
  venue: PropTypes.string,
  matchTime: PropTypes.string,
};
